export default __webpack_public_path__ + "static/media/logomca.320fb329.svg";